import { render, staticRenderFns } from "./app-content.vue?vue&type=template&id=ff1d1ff6"
import script from "./app-content.vue?vue&type=script&lang=ts"
export * from "./app-content.vue?vue&type=script&lang=ts"
import style0 from "./app-content.vue?vue&type=style&index=0&id=ff1d1ff6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1d1ff6')) {
      api.createRecord('ff1d1ff6', component.options)
    } else {
      api.reload('ff1d1ff6', component.options)
    }
    module.hot.accept("./app-content.vue?vue&type=template&id=ff1d1ff6", function () {
      api.rerender('ff1d1ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-content/app-content.vue"
export default component.exports